import styled from 'styled-components'
import ButtonStyle from '@material-ui/core/Button'
import MenuStyle  from "@material-ui/core/Menu";
import MenuItemStyle from "@material-ui/core/MenuItem";

export const Menu = styled(MenuStyle)`
&& {
    .MuiMenu-paper {
        margin-top: 50px;
    }       
    }
`

export const MenuItem = styled(MenuItemStyle)``


export const Header = styled.div`
    display: flex;
    justify-content: space-between;
    position: relative;
    align-items: center;
    margin: 24px 32px 0;
    h3 {
        cursor: pointer;
        color: ${props => props.theme.title};
        font-size: 18px;
        display: flex;
        align-items: center;

        >svg {
            max-height: .875rem;
            width: .875rem;
            margin-left: .5rem;
        }
    }
    > div {
        display: flex;

        >button {
            margin-left: 16px;
            svg {
                width: 14px;
                height: 14px;
                margin-right: 10px;
            }
        }
    }
`

export const Container = styled.div`
    width: 100%;
    height: calc(100% - 64px);
    max-height: 100%;
    flex-flow: column;
    p,label {
        color: ${props => props.theme.text};
        font-size: .75rem;
    }
    
    h4 {
        color: ${props => props.theme.text};
    }
`

export const Button = styled(ButtonStyle)`
    && {
        height: 32px;
        &.cancel {
            background-color: #F6F7FC;
            color: #7D3CE8;
        }
    }
`

export const ContainerFrame = styled.div`
	display: flex;
  flex-direction: column;
  justify-content: space-between;
	
`

export const EmptyDash = styled.div`
display: flex;
justify-content: center;
align-items: center;
width: 100%;
height: 100%;
color: #000;
`